import { flattenErrorTypeArray } from '@equifinance/shared';
import { StaticDataItem } from '../../../../api/useAccountApi';
import SecurityAddressDetails from './SecurityAddressDetails';
import PropertyDetails from './PropertyDetails';
import { SectionTitleIcon } from '../../Icons/SectionTitleIcon';
import { useAccountContext } from '../../../../contexts';
import { PaddedSection } from '../../components/Section';

export const SecurityDetailsRefName = 'security-details';

export default function SecurityDetails({
  ukCountries,
  lendingRegions,
}: {
  ukCountries: StaticDataItem[],
  lendingRegions: StaticDataItem[],
}) {
  const {
    account,
  } = useAccountContext();

  const {
    securityAddress,
    property,
    errors,
  } = account;

  const combinedErrors = flattenErrorTypeArray([
    ...(errors?.[securityAddress?.id] ?? []),
    ...(errors?.[property?.id] ?? []),
  ]);

  return (
    <PaddedSection
      id="security-details"
      refName={SecurityDetailsRefName}
      title="Security Details"
      titleIcon={<SectionTitleIcon errors={combinedErrors} />}
    >
      <>
        <SecurityAddressDetails
          ukCountries={ukCountries}
          lendingRegions={lendingRegions}
        />

        <PropertyDetails />
      </>
    </PaddedSection>
  );
}
